import React from "react";
import LabelValuePair from "../common/LabelValuePair";
import { AuditLog, AuditLogTypeLabels } from "../../models/AuditLog";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

import { dialogNarrow } from "@/lib/dialogSize";

/**
 * What a folder sweep request asked for.
 *
 * How many clients were flagged is the only outcome the request itself has — the sweep runs later, on each
 * client's own schedule, so nothing here says whether one has happened.
 */
export const ViewFolderSweepRequestedAuditLogDetailsModal: React.FC<{
  auditLog: AuditLog | null;
  open: boolean;
  onClose: () => void;
}> = ({ auditLog, open, onClose }) => {
  const clientsNotified = (() => {
    if (!auditLog?.newValue) return null;

    try {
      return JSON.parse(auditLog.newValue).ClientsNotified ?? null;
    } catch {
      return null;
    }
  })();

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className={`${dialogNarrow} overflow-hidden`}>
        {auditLog ? (
          <>
            <DialogHeader>
              <DialogTitle>{AuditLogTypeLabels[auditLog.eventType]}</DialogTitle>
            </DialogHeader>

            <Separator />

            <div className="flex flex-col gap-2 py-2">
              {clientsNotified !== null && (
                <LabelValuePair label="Clients flagged to sweep" value={clientsNotified} />
              )}

              {auditLog.additionalData && (
                <LabelValuePair label="Reason" value={auditLog.additionalData} />
              )}

              <LabelValuePair label="Performed by" value={auditLog.performerEmailAddress} />
              <LabelValuePair label="Event date" value={auditLog.eventDate} />
            </div>
          </>
        ) : (
          <div />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewFolderSweepRequestedAuditLogDetailsModal;
